import type { Method } from 'lib/axios';
import { APICallV4 } from 'reactApp/api/APICall';

type NestleRegisterPetResponseParams = { message: string } | { error: string };

export type NestleRegisterPetRequestParams = {
    mobile_file: Blob;
    desktop_file: Blob;
    metadata: {
        email: string;
        name?: string;
        pet: {
            alias: string;
            friends_alias: string;
            type: string;
            breed: string;
            birth_date?: number;
            is_sharable: boolean;
        };
    };
};

export class NestleRegisterPetApiCall extends APICallV4<NestleRegisterPetResponseParams> {
    _method = 'public/nestle/pet';
    _type: Method = 'post';
    _retriesCount = 0;
    _headers = { 'Content-Type': 'multipart/form-data' };
}
